import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage } from "./FirebaseConfig";

export const DocumentHandler = async (document,filename, fname,lname) => {
  try {
    if (!document) throw new Error("No document provided");

    const extension = document.name.split(".").pop();
    const fileName = `partner-documents/${fname}_${lname}/${filename}.${extension}`;

    const storageRef = ref(storage, fileName);
    const snapshot = await uploadBytes(storageRef, document);
    const downloadURL = await getDownloadURL(snapshot.ref);

    return { success: true, downloadURL };
  } catch (error) {
    return { success: false, error };
  }
};

export const ImageHandler = async (document, fname,lname) => {
  try {
    if (!document) throw new Error("No document provided");

    const extension = document.name.split(".").pop();
    const fileName = `partner-profiles/${fname}_${lname}/photo.${extension}`;

    const storageRef = ref(storage, fileName);
    const snapshot = await uploadBytes(storageRef, document);
    const downloadURL = await getDownloadURL(snapshot.ref);

    return { success: true, downloadURL };
  } catch (error) {
    return { success: false, error };
  }
};

export const WCPartnerHandle = async (document,filename, fname,lname) => {
  try {
    if (!document) throw new Error("No document provided");

    const extension = document.name.split(".").pop();
    const fileName = `wc-partner-documents/${fname}_${lname}/${filename}.${extension}`;

    const storageRef = ref(storage, fileName);
    const snapshot = await uploadBytes(storageRef, document);
    const downloadURL = await getDownloadURL(snapshot.ref);

    return { success: true, downloadURL };
  } catch (error) {
    return { success: false, error };
  }
};